/**
 * A situação do upload no filtro da tela de Uploads (2026-10-19) —
 * espelho de `core.vocabulary.UPLOAD_SITUATIONS`, com paridade travada
 * por `tests/test_upload_situation_parity.py` (lê este arquivo, inclusive
 * a SEQUÊNCIA, que é a ordem do seletor).
 *
 * Não é status: "Com pendências" é ter item pendente na fila de correção,
 * e cruza os status (um upload que falhou com fila aparece nas duas).
 */

export const UPLOAD_SITUATIONS = ["in_progress", "finished", "pending", "failed"] as const;

export type UploadSituation = (typeof UPLOAD_SITUATIONS)[number];

export const UPLOAD_SITUATION_LABELS: Record<UploadSituation, string> = {
  in_progress: "Em andamento",
  finished: "Concluídos",
  pending: "Com pendências",
  failed: "Falharam"
};
